import {
    createStore
} from 'vuex'

export default createStore({
    state: {
        userInfo: Object,
        BizToken: '',
        //新加的
        keyWord:''
    },
    mutations: {},
    actions: {},
    modules: {}
})